import React from 'react';
import { IWalkthroughModel } from 'src/services/client-types';
import WalkthroughSummaryItem from 'src/components/BulkOperations/Walkthroughs/BulkWalkthroughSummaryItem/WalkthroughSummaryItem';
import './BulkWalkthroughSummary.scss';

interface IBulkWalkthroughsSummaryProps {
  walkthroughs: IWalkthroughModel[];
  isCalcomConnected?: boolean;
}

const BulkWalkthroughsSummary = ({
  walkthroughs,
  isCalcomConnected = false,
}: IBulkWalkthroughsSummaryProps) => {
  return (
    <div className="bulk-summary-list">
      {walkthroughs.map((walkthrough: IWalkthroughModel, i: number) => (
        <WalkthroughSummaryItem
          key={walkthrough.id}
          walkthrough={walkthrough}
          index={i}
          isCalcomConnected={isCalcomConnected}
        />
      ))}
    </div>
  );
};

export default BulkWalkthroughsSummary;